export const Title =
  "Satvocab - The Free and Smart Way to Learn SAT Test Vocabulary Words";
export const Description =
  "Satvocab.com provides an innovative approach to learning vocabulary words for people of all ages. The idea is to establish a link between the word and definition through easy to remember stories. By creating a visual link, even the hardest to remember words can be memorized for life.";
export const Brand = "Satvocab";
export const MainMessage =
  "Hi, hope these top SAT words can help you  💯 the exam. GL 👍";
export const SubMessage =
  "Satvocab.com provides an innovative approach to learning vocabulary words for people of all ages. The idea is to establish a link between the word and definition through easy to remember stories. By creating a visual link, even the hardest to remember words can be memorized for life.";
